import { Component } from "@angular/core";
import { NewUiAuth0CallbackComponent } from "./new-ui-auth0Callback.component";

@Component({
  selector: "app-auth0-callback",
  templateUrl: "./auth0Callback.component.html",
})
export class Auth0CallbackComponent extends NewUiAuth0CallbackComponent {}
